export const DOCUMENT_FLOW_VALUES = ['none', 'bolla_elettronica'] as const;
export const ORDER_SEND_FORMAT_VALUES = ['peppol'] as const;
export const RECEPTION_FORMAT_VALUES = ['csv', 'edifact'] as const;

export type DocumentFlowValue = typeof DOCUMENT_FLOW_VALUES[number];
export type OrderSendFormatValue = typeof ORDER_SEND_FORMAT_VALUES[number];
export type ReceptionFormatValue = typeof RECEPTION_FORMAT_VALUES[number];

export const DEFAULT_DOCUMENT_FLOW: DocumentFlowValue = 'none';
export const DEFAULT_ORDER_SEND_FORMAT: OrderSendFormatValue = 'peppol';
export const DEFAULT_RECEPTION_FORMAT: ReceptionFormatValue = 'csv';

/** Map API value (incl. legacy pdf) to form option. */
export function toFormReceptionFormat(apiValue: string | undefined): ReceptionFormatValue {
  if (!apiValue || apiValue === 'pdf') {
    return 'csv';
  }
  if (apiValue === 'csv' || apiValue === 'edifact') {
    return apiValue;
  }
  return DEFAULT_RECEPTION_FORMAT;
}

const LEGACY_BOLLA_FLOWS = new Set(['email', 'edifact']);

/** True when integration format fields (invio/ricezione) should be shown. */
export function isFormBollaElettronica(documentFlow: string | undefined): boolean {
  return (
    documentFlow === 'bolla_elettronica' || documentFlow === 'email' || documentFlow === 'edifact'
  );
}

/** Map API value (incl. legacy email/edifact) to form option. */
export function toFormDocumentFlow(apiValue: string | undefined): DocumentFlowValue {
  if (!apiValue || apiValue === 'none') {
    return 'none';
  }
  if (apiValue === 'bolla_elettronica' || LEGACY_BOLLA_FLOWS.has(apiValue)) {
    return 'bolla_elettronica';
  }
  return DEFAULT_DOCUMENT_FLOW;
}
